import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components/macro'
import { rem } from 'polished'
import {
  Title, Text, Icon, Spacer
} from 'components/atoms';
import { Layout } from 'components/organisms';
import TextareaAutosize from 'react-autosize-textarea'
import { useDispatch } from 'react-redux'
import { saveDraft } from 'redux/draftsSlice'
import { useEditorContext, actions } from 'context/EditorContext';
import { useParams } from 'react-router-dom'
import { tryParseJSON } from 'services/helpers'
import { toast } from 'react-toastify';
import { Toast, Authenticator } from 'containers';
import { useDebounce } from 'react-use'

const EditorJSON = () => {
  const { pageId, lang } = useParams();
  const [{ pageLiveData }, dispatch] = useEditorContext();
  const dispatchRedux = useDispatch()
  const [textInput, setInput] = useState(JSON.stringify(pageLiveData, null, 2))

  useEffect(() => {
    setInput(JSON.stringify(pageLiveData, null, 2))
  }, [pageLiveData])

  const handleSave = () => {
    const newLiveData = tryParseJSON(textInput)

    if (!newLiveData) {
      toast.error(
        <Toast
          type="error"
          title="Estrutura de json inválida"
          description="Corrija a estrutura do json"
        />
      );
      return;
    }

    // verify if the new data is different before dispatching to context
    const pageLiveDataJSON = JSON.stringify(pageLiveData);
    const newLiveDataJSON = JSON.stringify(newLiveData)

    if (pageLiveDataJSON !== newLiveDataJSON) {
      dispatch({
        type: actions.PAGE_DATA_UPDATE,
        data: newLiveData,
      });
      dispatchRedux(saveDraft({ pageId, content: newLiveData, lang }))
    }
  };

  // debounce value
  useDebounce(
    () => {
      handleSave(textInput)
    },
    1000,
    [textInput]
  )

  const handleOnChange = (e) => {
    setInput(e.target.value)
  }

  return (
    <Layout modifiers={['fullscreen']}>
      <Page>
        <Page.Header>
          <Title>
            <Icon icon="fal fa-file-code" />
            <Spacer right="xs" />
            Editar JSON
          </Title>
          <Text>
            Aqui pode atualizar a estrutura de json da página diretamente.
          </Text>
        </Page.Header>
        <Page.Main>
          <Authenticator requires="admin" redirect="/">
            <TextareaAutosize
              value={textInput}
              onChange={handleOnChange}
            />
          </Authenticator>
        </Page.Main>
      </Page>
    </Layout>
  )
}


const Page = styled.div``;

Page.Header = styled.div`
  h1 {
    display: flex;
  }
  margin-bottom: ${props => props.theme.spacing.l};
`;

Page.Main = styled.div(props => css`
  width: 100%;
  textarea {
    width: 100%;
    line-height: 1.6;
    text-transform: none;
    font-size: ${rem('15px')};
    font-weight: ${props.theme.weight.light};
    letter-spacing: ${props.theme.values.letterSpacing};
    font-family: ${props.theme.type.base};
    color: ${(props.isThemeReverse
    ? props.theme.components.text.colorReverse
    : props.theme.components.text.color)};
    font-weight: ${props.theme.weight.light};
    padding: 1rem;
  }
`)

export default EditorJSON
